import { render, staticRenderFns } from "./BaseLoader.vue?vue&type=template&id=82d1a2ca&"
import script from "./BaseLoader.vue?vue&type=script&lang=js&"
export * from "./BaseLoader.vue?vue&type=script&lang=js&"
import style0 from "./BaseLoader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82d1a2ca')) {
      api.createRecord('82d1a2ca', component.options)
    } else {
      api.reload('82d1a2ca', component.options)
    }
    module.hot.accept("./BaseLoader.vue?vue&type=template&id=82d1a2ca&", function () {
      api.rerender('82d1a2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseLoader.vue"
export default component.exports